export default __webpack_public_path__ + "a96e078.png";